export default {
  open: async path => {
    window.open(path, '_blank', 'noopener,noreferrer');
  },
};
